import { formatTelefonHref } from '../lib/format.js';
import { useAktivitaetModal } from './AktivitaetModalProvider.jsx';

/**
 * Klickbare Telefonnummer.
 * - rendert <a href="tel:..."> sodass das System-Softphone öffnet
 * - öffnet zusätzlich das Aktivitäts-Modal vorausgefüllt mit Typ "Telefonat"
 *   für die übergebene Praxis (und optional einen Kontakt)
 *
 * Wenn keine praxisId gesetzt ist, fällt der Link auf reines tel: zurück
 * ohne Modal-Trigger (z. B. wenn die Komponente außerhalb eines Praxis-
 * Kontexts verwendet wird).
 */
export default function TelefonLink({
  phone,
  praxisId,
  kontaktId,
  kontakte,
  className,
  fallback = '—',
}) {
  const modal = useAktivitaetModal();

  if (!phone) {
    return <span className="text-slate-500">{fallback}</span>;
  }

  const href = formatTelefonHref(phone);
  if (!href) {
    return <span>{phone}</span>;
  }

  function handleClick() {
    if (!praxisId || !modal) return;
    modal.openCreate({
      praxisId,
      kontakte,
      prefill: {
        typ: 'telefonat',
        titel: 'Telefonat',
        kontakt: kontaktId || '',
      },
    });
  }

  return (
    <a
      href={href}
      onClick={handleClick}
      className={className ?? 'text-primary-700 hover:underline'}
    >
      {phone}
    </a>
  );
}
